import { Component, Input } from '@angular/core';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { commonService } from 'src/app/services/common.service';
import { AcdService } from '../../../../services/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-acd-steps',
  templateUrl: './acd-steps.component.html',
  styleUrl: './acd-steps.component.scss'
})
export class AcdStepsComponent {

  defineView = false;
  searchView = false;
  buildView = true;
  summaryView = false;
  summaryData = false;
  buildData = false;
  crDetails: any = null;
  crNo = 0;
  currentStep: string = '';

  @Input() set setStepDetails(stepDetails: any) {
    if (stepDetails) {
      this.stepClick(stepDetails.stepName, stepDetails.stepNumber, true);
    }
  }

  @Input() set setCRNo(crNo: number) {
    if (crNo > 0) {
      this.crNo = crNo
      this.commonService.setPageTitle(`EMDM CMMS - CR#${this.crNo}`)
      this.setCrDetails();
      
    }
  }
  

   public setCrDetails(){
     this.acdservice.viewAcd(this.crNo).subscribe((data: any) => {
       if (data) {
         this.crDetails = JSON.parse(JSON.stringify(data));
         this.summaryData = (this.crDetails?.build || this.crDetails?.status != 'Build') ? false : true;
         this.buildData = ((this.currentStep == 'Search' && this.crDetails?.build) || this.crDetails?.build || this.crDetails?.status != 'Build') ? false : true;
       }
     });
  }

  ngOnDestroy() {
    this.commonService.setPageTitle('EMDM CMMS');
  }
  crStatus = '';
  currentStepNo = 3;

  @Input() set setCRStatus(status: string) {
    if (status) {
      this.crStatus = status.toLocaleLowerCase()
    }
  }

  constructor(public iconPack: EmdmIcons, private commonService: commonService, private acdservice: AcdService,
    private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe(params => {
      const step = params['step'];
      if (step === 'Search') {
        this.currentStep = 'Search';       
      }
    });
  }
  backbtn = this.iconPack.FaCircleArrowLeft;
  viewReset() {
    this.defineView = false;
    this.searchView = false;
    this.buildView = false;
    this.summaryView = false;
  }

  stepClick(stepName: string, stepNo: number, isStepChangedFromParent: boolean = false, BuildType : string ='') {
    let isValid = true;
    if (!isStepChangedFromParent) {
      isValid = this.currentStepNo == 1 ? false : isValid;

      if (isValid) {
        isValid = this.currentStepNo == 2 && stepNo == 3 ? false : isValid;
      }

      if (isValid) {
        isValid = this.currentStepNo == 4 && stepNo == 3 ? false : isValid;
      }
    }

    if (isValid || isStepChangedFromParent) {
      this.viewReset();
      if (stepName == 'Define') {
        this.defineView = true;
        this.currentStepNo = 1;
      }
      else if (stepName == 'Search') {
        this.setCrDetails();
        this.searchView = true;
        this.currentStepNo = 2;
      }
      else if (stepName == 'Build') {
        this.buildView = true;
        this.currentStepNo = 3;
      }
      else if (stepName == 'Summary') {
        this.setCrDetails();
        this.summaryView = true;
        this.currentStepNo = 4;
      }
      if(BuildType == ''){
      this.commonService.updateQueryParams('step', stepName);}
      else {
        this.commonService.updateQueryParams('step', 'Search','buildType', 'JobPlan');
      }
    }
  }

  onSummaryClick(): void {
    if (this.summaryData) {
      return;
    }
    this.stepClick('Summary', 4);
  }

}
